<template>
	<div class="vote-table">
		<v-data-table
			class="overflow-x elevation-1"
			height="100%"
			item-key="name"
			hide-default-footer
			:headers="headers"
			:items="items"
			:loading="loading"
			:page.sync="options.page"
			:options="options"
			:server-items-length="options.itemsLength"
			@click:row="handleRowClick"
		>
			<!--  ХЭДЕР ТАБЛИЦЫ -->
			<template v-slot:top="{ pagination, options, updateOptions }">
				<v-data-footer
					class="justify-end pa-3 border-bottom"
					:pagination="pagination"
					:options="options"
					@update:options="updateOptions"
					items-per-page-text=""
					:items-per-page-options="[]"
					:disable-pagination="loading"
					:show-first-last-page="true"
				>
					<!-- <template v-slot:page-text>
						{{ options.page || "-" }} из {{ options.pageCount || "-" }}
					</template> -->
					<template v-slot:prepend>
						<div class="d-flex flex-sm-grow-1 align-center justify-start">
							<!-- Кнопка создания -->
							<v-btn
								class="mr-5"
								color="primary"
								@click="showModalCreate = true"
								small
								depressed
							>
								<v-icon class="mr-1" small>mdi-plus</v-icon>
								<span class="body-2 font-weight-light">Создать</span>
							</v-btn>
							<!-- Дата создания -->
							<div class="d-flex align-center mr-3">
								<span class="subtitle-2 grey--text mr-3">от</span>
								<DatePickerPlain
									:date.sync="filter.created_at_first_search"
									@change="updateQuery"
								/>
								<span class="mx-3 subtitle-2 grey--text">до</span>
								<DatePickerPlain
									:date.sync="filter.created_at_second_search"
									@change="updateQuery"
								/>
							</div>
							<!-- Сброс фильтров -->
							<v-btn
								class="mr-5 text-lowercase"
								color="primary"
								small
								outlined
								@click="resetFilters"
							>
								<span class="body-2 font-weight-light">
									<span class="text-capitalize">Сбросить</span> фильтры
								</span>
							</v-btn>
						</div>
					</template>
				</v-data-footer>
			</template>
			<!-- ФИЛЬТРЫ ТАБЛИЦЫ -->
			<template v-slot:[`body.prepend`]>
				<tr>
					<td>
						<v-text-field
							v-model="filter.pretty_id"
							class="border-all"
							solo
							dense
							flat
							hide-details
							placeholder="ID"
							@change="updateQuery"
						>
						</v-text-field>
					</td>
					<td>
						<combobox
							v-model="filter.street_search"
							placeholder="Адрес"
							:items="houses"
							@change="updateQuery"
							@select-all="updateFilter('street_search', $event)"
						/>
					</td>
					<td></td>
					<td></td>
					<td></td>
					<td>
						<combobox
							v-model="filter.status_ids"
							placeholder="Статус"
							itemText="name"
							:items="votesStatuses"
							@change="updateQuery"
							@select-all="updateFilter('status_ids', $event)"
						/>
					</td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
			</template>
			<template v-slot:[`item.id`]="{ item }">
				<td>
					<v-badge
						v-if="item.unread_comment"
						class="mr-2"
						color="red"
						dot
						overlap
						bordered
					>
						<v-icon color="primary" small>mdi-message-outline</v-icon>
					</v-badge>
					<span>{{ item.pretty_id }}</span>
				</td>
			</template>
			<template v-slot:[`item.house`]="{ item }">
				<td>
					{{ item.house.apartment_address }}
				</td>
			</template>
			<template v-slot:[`item.apartments`]="{ item }">
				<td>
					{{ hasRoomType(item, 'apartment') && item.house.gdbdrn_apartment_count !== 0 ? item.house.gdbdrn_apartment_count : "-" }}
				</td>
			</template>
			<template v-slot:[`item.non_residents`]="{ item }">
				<td>
					{{ hasRoomType(item, 'non-residential-premises') && item.house.gdbdrn_non_residential_premises_count !== 0 ? item.house.gdbdrn_non_residential_premises_count : "-" }}
				</td>
			</template>
			<template v-slot:[`item.parking`]="{ item }">
				<td>
					{{ hasRoomType(item, 'parking-space') && item.house.gdbdrn_parking_space_count !== 0 ? item.house.gdbdrn_parking_space_count : "-" }}
				</td>
			</template>
			<template v-slot:[`item.phone`]="{ item }">
				<td>
					{{ item.phone || "---" }}
				</td>
			</template>
			<template v-slot:[`item.employee_period_of_execution`]="{ item }">
				<td>
					{{ item.employee_period_of_execution }}
				</td>
			</template>
			<template v-slot:[`item.questions`]="{ item }">
				<td>
					<span v-if="item.questions.length" class="ma-3">
						<span v-for="(q, i) in item.questions" :key="i">
							<p v-if="i < 3" class="ma-0">{{ i+1 }}. {{ truncateText(q.description, 55) }}</p>
						</span>
					</span>
					<span v-else class="grey--text">Заполните поле</span>
				</td>
			</template>
			<template v-slot:[`item.created_at`]="{ item }">
				<td>
					{{ item.created_at | timestamp(true) }}
				</td>
			</template>
			<template v-slot:[`item.time_vote`]="{ item }">
				<td>
					<span v-if="item.date_begin && item.date_end">
						{{ item.date_begin | timestamp(true, { utc: false, hideTime: true }) }} - {{ item.date_end | timestamp(true, { utc: false, hideTime: true }) }}
					</span>
					<span v-else class="grey--text">Заполните поле</span>
					</td>
			</template>
			<template v-slot:[`item.publish`]="{ item }">
				<td>
					<span v-if="item.status" class="primary--text">{{ item.status.name }}</span>
				</td>
			</template>
		</v-data-table>
		<!-- ОКНО СОЗДАНИЯ ЗАЯВКИ -->
		<VoteNewTableModal
			v-if="showModalCreate"
			@update-info="updateQuery"
			@close-modal="showModalCreate = false"
		/>
	</div>
</template>

<script>
import { timestampToDdmmyyyy } from "@/helpers/helpers";
import { mapGetters } from "vuex";
import Combobox from '@/components/app/Combobox.vue';
import DatePickerPlain from "@/components/app/DatePickerPlain";
import VoteNewTableModal from "@/components/votes/VoteNewTableModal";

export default {
	name: "RequisitionsTable",
	components: {
		Combobox,
		DatePickerPlain,
		VoteNewTableModal,
	},
	watch: {
		options: {
			handler() {
				const query = { ...this.$route.query, page: this.options.page, sort_type: 'DESC' };
				this.$router.replace({ query });
				this.loadData(query);
			},
			deep: true,
		},
	},
	data() {
		return {
			items: [],
			filter: {
				house: this.$route.query.house || "",
				count_apartments: this.$route.query.count_apartments || "",
				created_at: this.$route.query.created_at || "",
				created_at_first_search:
					this.$route.query.created_at_first_search || "",
				created_at_second_search:
					this.$route.query.created_at_second_search || "",
				pretty_id: this.$route.query.pretty_id || "",
				house: this.$route.query.house || "",
				publish: this.$route.query.publish || "",
				questions: this.$route.query.questions || "",
				time_vote: this.$route.query.time_vote || "",
				street_search: this.$route.query.houses_ids || [],
				status_ids: this.$route.query.status_ids || [],
			},
			filtersQuery: {
				"house": "house",
				"count_apartments": "count_apartments",
				"created_at": "created_at",
				"created_at_first_search": "created_at_first",
				"created_at_second_search": "created_at_second",
				"pretty_id": "pretty_id",
				"questions": "questions",
				"time_vote": "time_vote",
				"publish": "publish",
				"street_search": "houses_ids",
				"status_ids": "status_ids",
			},
			headers: [
				{
					text: "№ ID",
					value: "id",
					width: "120px",
					sortable: false,
				},
				{
					text: "Адрес",
					value: "house",
					width: "200px",
					sortable: false,
				},
				{
					text: "Квартиры",
					value: "apartments",
					width: "100px",
					sortable: false,
				},
				{
					text: "НП",
					value: "non_residents",
					width: "100px",
					sortable: false,
				},
				{
					text: "Паркинг",
					value: "parking",
					width: "100px",
					sortable: false,
				},
				{
					text: "Опубликовано",
					value: "publish",
					width: "150px",
					sortable: false,
				},
				{
					text: "Вопросы",
					value: "questions",
					width: "250px",
					sortable: false,
				},
				{
					text: "Дата создания",
					value: "created_at",
					width: "150px",
					sortable: false,
				},
				{
					text: "Период голосования",
					value: "time_vote",
					width: "200px",
					sortable: false,
				},
			],
			options: {
				page: +this.$route.query.page || 1,
				itemsPerPage: 10,
				pageStart: 1,
				pageCount: 0,
				itemsLength: 0,
			},
			isExportingExcel: false,
			loading: true,
			showModalCreate: false,
		};
	},
	computed: {
		...mapGetters({
			catalog: "catalog/GET_CATALOG",
			houses: "ksk/GET_HOUSES",
			kskId: "auth/GET_KSK_ID",
			votesStatuses: "ksk/GET_VOTES_STATUSES",
		}),
	},
	methods: {
		timestampToDdmmyyyy,
		truncateText(text, maxLength) {
			if (text.length > maxLength) {
					return text.substring(0, maxLength) + '...';
			}
			return text;
    },
		hasRoomType(item, sysName) {
      return item.room_types.some(roomType => roomType.sys_name === sysName);
    },
		countApartments(item) {
			const nonResApts = item.count_non_residential_premises || 0;
			return item.count_apartments + item.count_parking_spaces + nonResApts;
		},

		getQuestions(item) {
			return item.questions.map(e => e.title).join(", ") || "---";
		},

		// ? Методы таблицы
		handleRowClick(e) {
			this.$router.push({ path: `/vote-new/${e.id}` });
		},

		async exportExcel() {
			this.isExportingExcel = true;
			const query = this.updateQuery(true);
			console.log(query);
			try {
				const res = await this.$api.ksk.export_requests_list(query);
				const link = document.createElement("a");
				link.href = res;
				link.download = `Заявки ${timestampToDdmmyyyy()}.xlsx`;
				link.click();
			} catch (error) {
				console.log(error);
			} finally {
				this.isExportingExcel = false;
			}
		},

		async resetFilters() {
			for (const key in this.filter) {
				this.filter[key] = "";
			}
			this.$router.replace({ query: null });
			await this.loadData({sort_type: 'DESC'});
		},

		async loadData(params) {
			this.loading = true;
			params.selected_ksk_id = this.kskId
			params.company_ids = [this.kskId]
			return this.$api.ksk
				.load_votes_new(params)
				.then(res => {
					this.options.page = res.currentPage;
					this.options.pageCount = res.pages;
					this.options.itemsLength = res.pages * 10;
					this.items = res.data;
				})
				.catch(error => {
					throw error;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateFilter(filterName, value) {
			console.log('filterName', filterName)
      this.filter[filterName] = value;
			this.updateQuery()
    },
		async updateQuery(getQuery = false) {
			const query = Object.entries(this.filter).reduce((acc, [key, val]) => {
				if (!val) return acc;
				return { ...acc, [this.filtersQuery[key]]: val };
			}, {});

			if (getQuery === true) {
				return query;
			}

			this.$router.replace({ query: { ...query, page: this.options.page, sort_type: 'DESC' } });
			if(!query.page) query.page = this.options.page
			if(!query.sort_type) query.sort_type = 'DESC'
			await this.loadData(query);
		},
		// ? Конец методов таблицы
	},

	async created() {
		this.$store.dispatch("ksk/load_houses");
		this.$store.dispatch("ksk/load_employee");
		this.$store.dispatch("ksk/load_votes_statuses");
	},

	async mounted() {
		try {
			const query = { ...this.$route.query, sort_type: 'DESC' };
			await this.loadData(query);
			console.log(this.items);
			this.loading = false;
		} catch (error) {
			console.error(error);
		}
	},
};
</script>

<style lang="scss" scoped>
.vote-table {
	height: 100vh;
}
::v-deep tbody tr:nth-child(1) td {
	height: 58px !important;
}
</style>
